

import {BIconTelephoneFill} from "bootstrap-vue";
import Vue from "vue";
import {RegistrationModelFactory} from "../../model/checkout/RegistrationModelFactory";
import {ContactFormInformation} from "../../model/rest/data-contracts";
import Captcha from "./Captcha.vue";
import {SelectionOption} from "./Types";

export enum InquiryType {
  COUNSELLING = "counselling",
  TRANSPORT = "transport",
  LOGISTICS = "logistics",
  STORAGE = "storage",
  HAZARDOUS_GOODS = "hazardous-goods",
  PACKAGING = "packaging"
}

export default Vue.extend({
  name: "ContactForm",
  components: {Captcha, BIconTelephoneFill},
  props: {
    selected: {
      type: String as () => InquiryType,
      required: false,
      default: InquiryType.COUNSELLING,
    },
  },
  data() {
    return {
      options: [
        {
          text: "Beratung",
          value: InquiryType.COUNSELLING,
        },
        {
          text: "Transport",
          value: InquiryType.TRANSPORT,
        },
        {
          text: "Logistik",
          value: InquiryType.LOGISTICS,
        },
        {
          text: "Lagern",
          value: InquiryType.STORAGE,
        },
        {
          text: "Gefahrgut",
          value: InquiryType.HAZARDOUS_GOODS,
        },
        {
          text: "Verpacken",
          value: InquiryType.PACKAGING,
        },
      ] as Array<SelectionOption>,
      form: {
        subject: this.selected,
        name: "",
        email: "",
        message: "",
      } as ContactFormInformation,
      captcha: RegistrationModelFactory.createEmptyCaptchaResponse(),
    };
  },
  methods: {
    async validateCaptcha(): Promise<boolean> {
      try {
        await this.$bl.userService.validateCaptcha(this.captcha);
        return true;
      } catch (e: any) {
        this.$toastUtil.error(e);
      }
      return false;
    },
    checkFormFieldValidity(): boolean {
      return this.form.subject !== "" &&
        this.form.name !== "" &&
        this.form.email !== "" &&
        this.form.message !== "";
    },
    async submitForm() {
      if (!(await this.validateCaptcha())) {
        return;
      }

      if (!this.checkFormFieldValidity()) {
        this.$toastUtil.error(this.$t("pages.contact.fillInFormCompletelyMessage"));
        return;
      }

      try {
        const subject = `Kontaktformularanfrage zum Thema '${this.options.find(option => option.value === this.form.subject)?.text ?? "Sonstiges"}'`;
        const response = await this.$bl.userService.contact(
          this.form.email,
          this.form.name,
          subject,
          this.form.message,
          this.captcha,
        );

        if (response === null) {
          this.$toastUtil.error(this.$t("pages.contact.serverSendMailErrorMessage"));
          return;
        }

        this.$toastUtil.success(this.$t("pages.contact.contactMailSentConfirmedMessage"));
        setTimeout(() => {
          this.$toastUtil.info(this.$t("pages.contact.contactAffirmationMessage"));
        }, 3000);

        this.clearForm();
      } catch (e: any) {
        this.$toastUtil.error(e);
      }
    },
    clearForm() {
      this.form.subject = "";
      this.form.name = "";
      this.form.email = "";
      this.form.message = "";
      this.captcha = RegistrationModelFactory.createEmptyCaptchaResponse();
    },
  },
});
